/**
 * Centralized client-side storage keys.
 *
 * Keep every `localStorage` / `sessionStorage` key string here so we can audit
 * persisted state in one place and avoid typo drift between read and write
 * sites.
 *
 * Static keys live on `STORAGE_KEYS`. Per-user/per-entity keys are exposed as
 * helper functions so callers can't accidentally interpolate the wrong field.
 */

export const STORAGE_KEYS = {
  /** Set to "true" while the user is browsing in unauthenticated guest mode. */
  GUEST: "guest",
  /** Tracks whether the user has ever signed in on this device (switches splash CTA). */
  HAS_LOGGED_IN_BEFORE: "hasLoggedInBefore",
  /** Persists the in-progress Add-Burger form between sessions. */
  CHECKIN_DRAFT: "brrgr_checkin_draft",
} as const;

/** GA4 signup_complete conversion — fired once per user-id. */
export const signupTrackedKey = (userId: string) => `signup_tracked_${userId}`;

/** GA4 first_checkin funnel event — fired once per user-id. */
export const firstCheckinTrackedKey = (userId: string) => `first_checkin_tracked_${userId}`;

/** Per-user dismissal timestamp for the "complete your profile" home banner. */
export const profilePromptDismissedKey = (userId: string) =>
  `profile_prompt_dismissed_${userId}`;
